export default "__VITE_ASSET__D7aqIXI9__"